import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachPreparationItemFolder from '../attachPreparationItemFolder';
import attachPreparationItemDocument from '../attachPreparationItemDocument';
import attachPreparationItemReportFolder from '../attachPreparationItemReportFolder';
import attachPreparationItemReport from '../attachPreparationItemReport';
import controller from './attach-preparation-item-dialog.controller';
import template from './attach-preparation-item-dialog.html';


class dialogService {
  getOptions($event, { serviceId, preparationItemId, folder }) {
    return {
      controller,
      controllerAs: 'attachPreparationItemDialogVM',
      locals: {
        serviceId,
        preparationItemId,
        folder
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.attachPreparationItemDialog', [
  alerts,
  amDataService,
  attachPreparationItemDocument,
  attachPreparationItemFolder,
  attachPreparationItemReport,
  attachPreparationItemReportFolder,
  constants,
  docDataService,
  loaderService,
  ssDialogService,
  userService,
])
  .service('attachPreparationItemDialog', dialogService)
  .name;
